module.exports = __webpack_public_path__ + "img/4800.1e86a8cd.jpg";